/**
 * app.blade.php renders <link rel="canonical"> and <meta property="og:url"> once, from the
 * server-rendered request's own URL - correct on first load, but Inertia client-side
 * navigation (category -> product, etc.) swaps the page body without touching those tags, so
 * they keep pointing at whatever page was first loaded. Googlebot always re-fetches each URL
 * fresh, so this is harmless for indexing, but a repost/share action reading the live DOM (or a
 * browser "copy canonical link" extension) would get the wrong URL after any in-app navigation.
 *
 * Only the URL itself is corrected here, not og:title/og:description - those already come from
 * each page's own <Head> block (see Product/Show.vue, Offer/Show.vue, ProductPage/Show.vue,
 * SellerPage/Show.vue), which Inertia's <Head> component already keeps in sync on navigation.
 */
export function updateCanonicalAndOgUrl() {
    if (typeof document === 'undefined') {
        return;
    }

    const url = window.location.origin + window.location.pathname;

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
        canonical.setAttribute('href', url);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
        ogUrl.setAttribute('content', url);
    }
}
